// extracted by mini-css-extract-plugin
module.exports = {"memberCol":"GroupList_memberCol_1MOwH"};